import CampaignIcon from "@mui/icons-material/Campaign";
import RedirectToTab from "../RedirectToCampaignTab";
import ListCampaigns from "./List";
import { CAMPAIGNS, CandidateServicePath, PRELIMINARY } from "utils/constants";
import CreateCampaigns from "./Create";
import EditCampaigns from "./Edit/Edit";
import ShowCampaign from "./Show";
import permissions from "app/permissions";
import { tenants } from "utils/tenants";

//permissions
export const resources = {
  isMenu: false,
  tenancies: [tenants.MU],
  icon: <CampaignIcon />,
  name: CandidateServicePath + CAMPAIGNS + `/${PRELIMINARY}`,
  title: "Предварителни кампании",
  list: <RedirectToTab type={PRELIMINARY} />,
  tabList: <ListCampaigns />,
  create: <CreateCampaigns />,
  createPermission: permissions.canCreateCampaigns,
  edit: <EditCampaigns />,
  editPermission: permissions.canUpdateCampaigns,
  show: <ShowCampaign />,
  showPermission: permissions.canPreviewCampaigns,
  permission: permissions.canPreviewCampaigns,
};
